import sanityClient from '@sanity/client'


export default sanityClient({
    projectId:"68d1bkl8",
    dataset:"production",
    apiVersion: '2021-08-21',
    useCdn: true
})